export default __webpack_public_path__ + "static/O0263-f1e54a7109f8d3c5a780a705d1764462.png";